import React from "react";
import cx from "classnames";
import Link from "next/link";

import { localizeText } from "@/utils/localizeText";

const getTarget = (isEmbedded: boolean) => (isEmbedded ? "_blank" : "_self");

type FinePrintProps = {
  country: string;
  showTerms?: boolean;
  className?: string;
  isEmbedded?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
  [x: string]: any;
};

const FinePrintUS = () => {
  return (
    <React.Fragment>
      Estimated total may not reflect actual taxes owed or other promotions.
      Payment is made directly to the dispensary at time of pickup/delivery.
      Pickup/delivery orders that exceed local limits or that include items no
      longer available may be modified. A dispensary agent may reach out to you
      if modifications must be made.
    </React.Fragment>
  );
};

const FinePrintCA = () => {
  return (
    <React.Fragment>
      Subtotal may not include tax or other promotions. Pickup/delivery orders
      that exceed local limits or that include items no longer available may be
      modified. A {localizeText("dispensary", "CA")} agent may reach out to you
      if necessary to complete your order.
    </React.Fragment>
  );
};

const FinePrint: React.FC<FinePrintProps> = ({
  country = "US",
  showTerms = false,
  className,
  isEmbedded,
}) => (
  <div id="fine-print" className={cx("text-xs", className)}>
    {showTerms && (
      <span>
        I agree to the{" "}
        <Link
          href="/info/terms-of-use"
          className="underline text-green"
          rel="noreferrer noopener"
          target={getTarget(!!isEmbedded)}
        >
          Terms of Use
        </Link>{" "}
        and have read the{" "}
        <Link
          href="/info/privacy-policy"
          className="underline text-green"
          rel="noreferrer noopener"
          target={getTarget(!!isEmbedded)}
        >
          Privacy Policy
        </Link>
        .
      </span>
    )}{" "}
    {country === "US" ? <FinePrintUS /> : <FinePrintCA />}
  </div>
);

export default FinePrint;
